/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface NotesService {
  /** @summary Create */
  createNotesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateNotesPostBody, CreateNotesPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateNotesPostSchema,
        options: ServiceOperationMutationFnOptions<CreateNotesPostBody, CreateNotesPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateNotesPostData, CreateNotesPostError>>
    ): Promise<RequestFnResponse<CreateNotesPostData, CreateNotesPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateNotesPostParameters> | void
    ): ServiceOperationMutationKey<CreateNotesPostSchema, CreateNotesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.createNotesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.createNotesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateNotesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateNotesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateNotesPostSchema,
        CreateNotesPostData,
        CreateNotesPostParameters,
        TVariables,
        OperationError<CreateNotesPostError>,
        TContext
      >
    ): UseMutationResult<CreateNotesPostData, OperationError<CreateNotesPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.createNotesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.createNotesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateNotesPostBody, CreateNotesPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateNotesPostSchema,
        CreateNotesPostData,
        CreateNotesPostParameters,
        TVariables,
        OperationError<CreateNotesPostError>,
        TContext
      >
    ): UseMutationResult<CreateNotesPostData, OperationError<CreateNotesPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createNotesPostTotal = qraft.notesService.createNotesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createNotesPostTotal = qraft.notesService.createNotesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateNotesPostBody,
            CreateNotesPostData,
            CreateNotesPostParameters,
            OperationError<CreateNotesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotesPostSchema,
            CreateNotesPostBody,
            CreateNotesPostData,
            CreateNotesPostParameters,
            OperationError<CreateNotesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createNotesPostPendingMutationVariables = qraft.notesService.createNotesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createNotesPostMutationData = qraft.notesService.createNotesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateNotesPostData,
        OperationError<CreateNotesPostError>,
        MutationVariables<CreateNotesPostBody, CreateNotesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateNotesPostBody,
            CreateNotesPostData,
            CreateNotesPostParameters,
            OperationError<CreateNotesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotesPostSchema,
            CreateNotesPostBody,
            CreateNotesPostData,
            CreateNotesPostParameters,
            OperationError<CreateNotesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateNotesPostData,
          OperationError<CreateNotesPostError>,
          MutationVariables<CreateNotesPostBody, CreateNotesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateNotesPostBody,
            CreateNotesPostData,
            CreateNotesPostParameters,
            OperationError<CreateNotesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateNotesPostSchema,
            CreateNotesPostBody,
            CreateNotesPostData,
            CreateNotesPostParameters,
            OperationError<CreateNotesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notesService.createNotesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notesService.createNotesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateNotesPostBody,
              CreateNotesPostData,
              CreateNotesPostParameters,
              OperationError<CreateNotesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateNotesPostSchema,
              CreateNotesPostBody,
              CreateNotesPostData,
              CreateNotesPostParameters,
              OperationError<CreateNotesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateNotesPostData,
            CreateNotesPostError,
            MutationVariables<CreateNotesPostBody, CreateNotesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateNotesPostBody,
              CreateNotesPostData,
              CreateNotesPostParameters,
              OperationError<CreateNotesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateNotesPostSchema,
              CreateNotesPostBody,
              CreateNotesPostData,
              CreateNotesPostParameters,
              OperationError<CreateNotesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateNotesPostData,
          CreateNotesPostError,
          MutationVariables<CreateNotesPostBody, CreateNotesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateNotesPostSchema;
    types: {
      parameters: CreateNotesPostParameters;
      data: CreateNotesPostData;
      error: CreateNotesPostError;
      body: CreateNotesPostBody;
    };
  };
  /** @summary Remove */
  removeNotesNoteIdDelete: {
    /** @summary Remove */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        RemoveNotesNoteIdDeleteBody,
        RemoveNotesNoteIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: RemoveNotesNoteIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          RemoveNotesNoteIdDeleteBody,
          RemoveNotesNoteIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<RemoveNotesNoteIdDeleteData, RemoveNotesNoteIdDeleteError>>
    ): Promise<RequestFnResponse<RemoveNotesNoteIdDeleteData, RemoveNotesNoteIdDeleteError>>;
    /** @summary Remove */
    getMutationKey(
      parameters: DeepReadonly<RemoveNotesNoteIdDeleteParameters> | void
    ): ServiceOperationMutationKey<RemoveNotesNoteIdDeleteSchema, RemoveNotesNoteIdDeleteParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.removeNotesNoteIdDelete.useMutation({
     *     path: {
     *         note_id: noteId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.removeNotesNoteIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         note_id: noteId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends RemoveNotesNoteIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<RemoveNotesNoteIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        RemoveNotesNoteIdDeleteSchema,
        RemoveNotesNoteIdDeleteData,
        RemoveNotesNoteIdDeleteParameters,
        TVariables,
        OperationError<RemoveNotesNoteIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveNotesNoteIdDeleteData,
      OperationError<RemoveNotesNoteIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.removeNotesNoteIdDelete.useMutation({
     *     path: {
     *         note_id: noteId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.removeNotesNoteIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         note_id: noteId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<RemoveNotesNoteIdDeleteBody, RemoveNotesNoteIdDeleteParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        RemoveNotesNoteIdDeleteSchema,
        RemoveNotesNoteIdDeleteData,
        RemoveNotesNoteIdDeleteParameters,
        TVariables,
        OperationError<RemoveNotesNoteIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      RemoveNotesNoteIdDeleteData,
      OperationError<RemoveNotesNoteIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const removeNotesNoteIdDeleteTotal = qraft.notesService.removeNotesNoteIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const removeNotesNoteIdDeleteTotal = qraft.notesService.removeNotesNoteIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             note_id: noteId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            RemoveNotesNoteIdDeleteBody,
            RemoveNotesNoteIdDeleteData,
            RemoveNotesNoteIdDeleteParameters,
            OperationError<RemoveNotesNoteIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveNotesNoteIdDeleteSchema,
            RemoveNotesNoteIdDeleteBody,
            RemoveNotesNoteIdDeleteData,
            RemoveNotesNoteIdDeleteParameters,
            OperationError<RemoveNotesNoteIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const removeNotesNoteIdDeletePendingMutationVariables = qraft.notesService.removeNotesNoteIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const removeNotesNoteIdDeleteMutationData = qraft.notesService.removeNotesNoteIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 note_id: noteId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        RemoveNotesNoteIdDeleteData,
        OperationError<RemoveNotesNoteIdDeleteError>,
        MutationVariables<RemoveNotesNoteIdDeleteBody, RemoveNotesNoteIdDeleteParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            RemoveNotesNoteIdDeleteBody,
            RemoveNotesNoteIdDeleteData,
            RemoveNotesNoteIdDeleteParameters,
            OperationError<RemoveNotesNoteIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveNotesNoteIdDeleteSchema,
            RemoveNotesNoteIdDeleteBody,
            RemoveNotesNoteIdDeleteData,
            RemoveNotesNoteIdDeleteParameters,
            OperationError<RemoveNotesNoteIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          RemoveNotesNoteIdDeleteData,
          OperationError<RemoveNotesNoteIdDeleteError>,
          MutationVariables<RemoveNotesNoteIdDeleteBody, RemoveNotesNoteIdDeleteParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Remove */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            RemoveNotesNoteIdDeleteBody,
            RemoveNotesNoteIdDeleteData,
            RemoveNotesNoteIdDeleteParameters,
            OperationError<RemoveNotesNoteIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            RemoveNotesNoteIdDeleteSchema,
            RemoveNotesNoteIdDeleteBody,
            RemoveNotesNoteIdDeleteData,
            RemoveNotesNoteIdDeleteParameters,
            OperationError<RemoveNotesNoteIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Remove
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notesService.removeNotesNoteIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             note_id: noteId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notesService.removeNotesNoteIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              RemoveNotesNoteIdDeleteBody,
              RemoveNotesNoteIdDeleteData,
              RemoveNotesNoteIdDeleteParameters,
              OperationError<RemoveNotesNoteIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveNotesNoteIdDeleteSchema,
              RemoveNotesNoteIdDeleteBody,
              RemoveNotesNoteIdDeleteData,
              RemoveNotesNoteIdDeleteParameters,
              OperationError<RemoveNotesNoteIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            RemoveNotesNoteIdDeleteData,
            RemoveNotesNoteIdDeleteError,
            MutationVariables<RemoveNotesNoteIdDeleteBody, RemoveNotesNoteIdDeleteParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              RemoveNotesNoteIdDeleteBody,
              RemoveNotesNoteIdDeleteData,
              RemoveNotesNoteIdDeleteParameters,
              OperationError<RemoveNotesNoteIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              RemoveNotesNoteIdDeleteSchema,
              RemoveNotesNoteIdDeleteBody,
              RemoveNotesNoteIdDeleteData,
              RemoveNotesNoteIdDeleteParameters,
              OperationError<RemoveNotesNoteIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          RemoveNotesNoteIdDeleteData,
          RemoveNotesNoteIdDeleteError,
          MutationVariables<RemoveNotesNoteIdDeleteBody, RemoveNotesNoteIdDeleteParameters>,
          TContext
        >
      >;
    };
    schema: RemoveNotesNoteIdDeleteSchema;
    types: {
      parameters: RemoveNotesNoteIdDeleteParameters;
      data: RemoveNotesNoteIdDeleteData;
      error: RemoveNotesNoteIdDeleteError;
      body: RemoveNotesNoteIdDeleteBody;
    };
  };
  /** @summary Pin */
  pinNotesNoteIdPinPost: {
    /** @summary Pin */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        PinNotesNoteIdPinPostBody,
        PinNotesNoteIdPinPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: PinNotesNoteIdPinPostSchema,
        options: ServiceOperationMutationFnOptions<
          PinNotesNoteIdPinPostBody,
          PinNotesNoteIdPinPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<PinNotesNoteIdPinPostData, PinNotesNoteIdPinPostError>>
    ): Promise<RequestFnResponse<PinNotesNoteIdPinPostData, PinNotesNoteIdPinPostError>>;
    /** @summary Pin */
    getMutationKey(
      parameters: DeepReadonly<PinNotesNoteIdPinPostParameters> | void
    ): ServiceOperationMutationKey<PinNotesNoteIdPinPostSchema, PinNotesNoteIdPinPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Pin
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.pinNotesNoteIdPinPost.useMutation({
     *     path: {
     *         note_id: noteId
     *     },
     *     query: {
     *         pinned: pinned
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.pinNotesNoteIdPinPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         note_id: noteId
     *     },
     *     query: {
     *         pinned: pinned
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends PinNotesNoteIdPinPostBody, TContext = unknown>(
      parameters: DeepReadonly<PinNotesNoteIdPinPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        PinNotesNoteIdPinPostSchema,
        PinNotesNoteIdPinPostData,
        PinNotesNoteIdPinPostParameters,
        TVariables,
        OperationError<PinNotesNoteIdPinPostError>,
        TContext
      >
    ): UseMutationResult<
      PinNotesNoteIdPinPostData,
      OperationError<PinNotesNoteIdPinPostError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Pin
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.pinNotesNoteIdPinPost.useMutation({
     *     path: {
     *         note_id: noteId
     *     },
     *     query: {
     *         pinned: pinned
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.notesService.pinNotesNoteIdPinPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         note_id: noteId
     *     },
     *     query: {
     *         pinned: pinned
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<PinNotesNoteIdPinPostBody, PinNotesNoteIdPinPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        PinNotesNoteIdPinPostSchema,
        PinNotesNoteIdPinPostData,
        PinNotesNoteIdPinPostParameters,
        TVariables,
        OperationError<PinNotesNoteIdPinPostError>,
        TContext
      >
    ): UseMutationResult<PinNotesNoteIdPinPostData, OperationError<PinNotesNoteIdPinPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Pin
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const pinNotesNoteIdPinPostTotal = qraft.notesService.pinNotesNoteIdPinPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const pinNotesNoteIdPinPostTotal = qraft.notesService.pinNotesNoteIdPinPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             note_id: noteId
     *         },
     *         query: {
     *             pinned: pinned
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            PinNotesNoteIdPinPostBody,
            PinNotesNoteIdPinPostData,
            PinNotesNoteIdPinPostParameters,
            OperationError<PinNotesNoteIdPinPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PinNotesNoteIdPinPostSchema,
            PinNotesNoteIdPinPostBody,
            PinNotesNoteIdPinPostData,
            PinNotesNoteIdPinPostParameters,
            OperationError<PinNotesNoteIdPinPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Pin
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const pinNotesNoteIdPinPostPendingMutationVariables = qraft.notesService.pinNotesNoteIdPinPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const pinNotesNoteIdPinPostMutationData = qraft.notesService.pinNotesNoteIdPinPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 note_id: noteId
     *             },
     *             query: {
     *                 pinned: pinned
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        PinNotesNoteIdPinPostData,
        OperationError<PinNotesNoteIdPinPostError>,
        MutationVariables<PinNotesNoteIdPinPostBody, PinNotesNoteIdPinPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            PinNotesNoteIdPinPostBody,
            PinNotesNoteIdPinPostData,
            PinNotesNoteIdPinPostParameters,
            OperationError<PinNotesNoteIdPinPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PinNotesNoteIdPinPostSchema,
            PinNotesNoteIdPinPostBody,
            PinNotesNoteIdPinPostData,
            PinNotesNoteIdPinPostParameters,
            OperationError<PinNotesNoteIdPinPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          PinNotesNoteIdPinPostData,
          OperationError<PinNotesNoteIdPinPostError>,
          MutationVariables<PinNotesNoteIdPinPostBody, PinNotesNoteIdPinPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Pin */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            PinNotesNoteIdPinPostBody,
            PinNotesNoteIdPinPostData,
            PinNotesNoteIdPinPostParameters,
            OperationError<PinNotesNoteIdPinPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            PinNotesNoteIdPinPostSchema,
            PinNotesNoteIdPinPostBody,
            PinNotesNoteIdPinPostData,
            PinNotesNoteIdPinPostParameters,
            OperationError<PinNotesNoteIdPinPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Pin
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.notesService.pinNotesNoteIdPinPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             note_id: noteId
     *         },
     *         query: {
     *             pinned: pinned
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.notesService.pinNotesNoteIdPinPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              PinNotesNoteIdPinPostBody,
              PinNotesNoteIdPinPostData,
              PinNotesNoteIdPinPostParameters,
              OperationError<PinNotesNoteIdPinPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PinNotesNoteIdPinPostSchema,
              PinNotesNoteIdPinPostBody,
              PinNotesNoteIdPinPostData,
              PinNotesNoteIdPinPostParameters,
              OperationError<PinNotesNoteIdPinPostError>,
              TContext
            >
      ):
        | Mutation<
            PinNotesNoteIdPinPostData,
            PinNotesNoteIdPinPostError,
            MutationVariables<PinNotesNoteIdPinPostBody, PinNotesNoteIdPinPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              PinNotesNoteIdPinPostBody,
              PinNotesNoteIdPinPostData,
              PinNotesNoteIdPinPostParameters,
              OperationError<PinNotesNoteIdPinPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              PinNotesNoteIdPinPostSchema,
              PinNotesNoteIdPinPostBody,
              PinNotesNoteIdPinPostData,
              PinNotesNoteIdPinPostParameters,
              OperationError<PinNotesNoteIdPinPostError>,
              TContext
            >
      ): Array<
        Mutation<
          PinNotesNoteIdPinPostData,
          PinNotesNoteIdPinPostError,
          MutationVariables<PinNotesNoteIdPinPostBody, PinNotesNoteIdPinPostParameters>,
          TContext
        >
      >;
    };
    schema: PinNotesNoteIdPinPostSchema;
    types: {
      parameters: PinNotesNoteIdPinPostParameters;
      data: PinNotesNoteIdPinPostData;
      error: PinNotesNoteIdPinPostError;
      body: PinNotesNoteIdPinPostBody;
    };
  };
}
/** @summary Create */
export const createNotesPost = {
  schema: {
    method: 'post',
    url: '/notes',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateNotesPostSchema;
  [QraftServiceOperationsToken]: NotesService['createNotesPost'];
};
/** @summary Remove */
export const removeNotesNoteIdDelete = {
  schema: {
    method: 'delete',
    url: '/notes/{note_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: RemoveNotesNoteIdDeleteSchema;
  [QraftServiceOperationsToken]: NotesService['removeNotesNoteIdDelete'];
};
/** @summary Pin */
export const pinNotesNoteIdPinPost = {
  schema: {
    method: 'post',
    url: '/notes/{note_id}/pin',
    security: ['HTTPBearer'],
  },
} as {
  schema: PinNotesNoteIdPinPostSchema;
  [QraftServiceOperationsToken]: NotesService['pinNotesNoteIdPinPost'];
};
export const notesService = {
  createNotesPost,
  removeNotesNoteIdDelete,
  pinNotesNoteIdPinPost,
} as const;
type CreateNotesPostSchema = {
  method: 'post';
  url: '/notes';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateNotesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateNotesPostData = paths['/notes']['post']['responses']['200']['content']['application/json'];
type CreateNotesPostError = paths['/notes']['post']['responses']['422']['content']['application/json'];
type CreateNotesPostBody = paths['/notes']['post']['requestBody']['content']['application/json'];
type RemoveNotesNoteIdDeleteSchema = {
  method: 'delete';
  url: '/notes/{note_id}';
  security: ['HTTPBearer'];
};
type RemoveNotesNoteIdDeleteParameters = paths['/notes/{note_id}']['delete']['parameters'];
type RemoveNotesNoteIdDeleteData =
  paths['/notes/{note_id}']['delete']['responses']['200']['content']['application/json'];
type RemoveNotesNoteIdDeleteError =
  paths['/notes/{note_id}']['delete']['responses']['422']['content']['application/json'];
type RemoveNotesNoteIdDeleteBody = undefined;
type PinNotesNoteIdPinPostSchema = {
  method: 'post';
  url: '/notes/{note_id}/pin';
  security: ['HTTPBearer'];
};
type PinNotesNoteIdPinPostParameters = paths['/notes/{note_id}/pin']['post']['parameters'];
type PinNotesNoteIdPinPostData =
  paths['/notes/{note_id}/pin']['post']['responses']['200']['content']['application/json'];
type PinNotesNoteIdPinPostError =
  paths['/notes/{note_id}/pin']['post']['responses']['422']['content']['application/json'];
type PinNotesNoteIdPinPostBody = undefined;
